<template>
  <b-modal id="weather-modal" size="md" title="Current weather" hide-footer>
    <div v-if="!hasWeatherData" class="text-center p-4">
      <p>No weather data available for the selected ship</p>
    </div>
    <div v-else class="weather-summary">
      <div class="ship-name mb-2">{{ shipName }}</div>
      <div class="weather-info">
<!--        <div class="weather-item">-->
<!--          <i class="fas fa-thermometer-half mr-2"></i>-->
<!--          <span>{{ temperature }}°C</span>-->
<!--        </div>-->
        <div class="weather-item">
          <i class="fas fa-wind mr-2"></i>
<!--          <span :class="{'text-danger': windSpeed > 8, 'text-success': windSpeed <= 1}">-->
            {{ windSpeed }}
<!--        m/s-->
<!--          </span>-->
        </div>
<!--        <div class="weather-item">-->
<!--          <i class="fas fa-compass mr-2"></i>-->
<!--          <span>{{ windDirection }}°</span>-->
<!--        </div>-->
<!--        <div class="weather-item">-->
<!--          <i class="fas fa-clock mr-2"></i>-->
<!--          <span>{{ updatedTime }}</span>-->
<!--        </div>-->
      </div>
    </div>
  </b-modal>
</template>

<script>
import {mapStores} from "pinia";
import {useFleetStore} from "@/stores/fleet";

export default {
  props: {
    weatherData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapStores(useFleetStore),
    // Проверяем, есть ли данные о погоде
    hasWeatherData() {
      return Object.keys(this.weatherData).length > 0;
    },
    // Получаем ID устройства
    deviceId() {
      return Object.keys(this.weatherData)[0] || '';
    },
    // Данные об имени судна
    shipName() {
      if (!this.hasWeatherData) return '';
      const data = this.weatherData[this.deviceId];
      return data?.shipName || this.deviceId;
    },
    // Получаем данные о температуре
    temperature() {
      if (!this.hasWeatherData) return '';
      return this.weatherData[this.deviceId].temperature;
    },
    // Получаем данные о скорости ветра
    windSpeed() {
      if (!this.hasWeatherData) return '';
      return this.weatherData[this.deviceId].wind;
    },
    // Получаем данные о направлении ветра
    windDirection() {
      if (!this.hasWeatherData) return '';
      return this.weatherData[this.deviceId].windAngle;
    },
    // Получаем время последнего обновления
    updatedTime() {
      if (!this.hasWeatherData) return '';
      const timestamp = this.weatherData[this.deviceId].timestamp;
      if (!timestamp) return 'Unknown';
      return new Date(timestamp * 1000).toLocaleString();
    }
  }
}
</script>

<style scoped>
.weather-summary {
  padding: 0.5rem;
}

.ship-name {
  font-size: 1.2rem;
  font-weight: 500;
}

.weather-info {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.weather-item {
  display: flex;
  align-items: center;
}
</style>